import React from "react";
import {Link} from "react-router-dom";
import { sidebarDesktopItems } from "../../utils/sideBarItems";
const SidebarLinkGroup = () => {
  return (
    <div className="pt-[25px]">
      {sidebarDesktopItems?.map((item, index) => (
        <Link to={item.url}>
        <div
          key={index}
          className="mt-[4px] flex items-center px-[6px] py-[12px] hover:bg-[#12283B] hover:rounded-[10px] hover:border-[1px] hover:border-[#17324B] cursor-pointer"
        >
          <img src={item.icon} alt="" />
          <p className="text-[14px] text-white pl-[12px]">{item.name}</p>
        </div>
        </Link>
      ))}
    </div>
  );
};

export default SidebarLinkGroup;
